import React, { ReactNode } from "react"
import {
  Flex, Heading, Text, TypographyProps,
  Stack,
} from "@chakra-ui/react"

interface Props {
  children?: string;
  description?: string | ReactNode;
  actionButtons?: ReactNode[];
  headingSize?: TypographyProps["fontSize"];
}

const SectionHeader = ({
  children, description, actionButtons, headingSize = "2xl",
}: Props) => (
  <Flex direction="column" gap={2}>
    <Flex justify="space-between" align="center" gap={8}>
      <Heading fontSize={headingSize}>{children}</Heading>
      {actionButtons && (
        <Flex gap={3}>
          {actionButtons.map((button, index) => <span key={index}>{button}</span>)}
        </Flex>
      )}
    </Flex>
    {description && <Description description={description} />}
  </Flex>
)

const Description = ({ description }: { description: string | ReactNode }) => {
  if (typeof description === "string") {
    return <Text fontSize="lg" color="gray.800">{description}</Text>
  }

  return <Stack spacing={2} fontSize="lg" color="gray.800">{description}</Stack>
}

export default SectionHeader
